module.exports = __webpack_public_path__ + "img/open.cabccbf5.svg";